import noUiSlider from 'nouislider'
import wNumb from 'wnumb'
import renderSlider from './render-slider'

export default async function(options) {
    const { slider, input, coinData, maxValue, step, defaultValue } = options

    noUiSlider.create(slider, {
        start: [defaultValue],
        connect: [true, false],
        tooltips: false,
        step,
        range: {
            min: [0],
            max: [maxValue]
        },
        format: wNumb({
            decimals:0
        })
    })

    await renderSlider({slider, input, coinData})
}